import {
  allQueryValues,
  firstQueryValue,
  parseQueryString,
} from "lib/links/query";
import { assertUnreachable } from "lib/assertUnreachable";
import { deletedUsername } from "lib/users/users";
import { EntriesRequestFilters } from "lib/entries/types";

export const parseQuery = (
  query: string,
  currentFilters: EntriesRequestFilters
): EntriesRequestFilters => {
  const parsed = parseQueryString(query);
  let entriesRequestFilters: EntriesRequestFilters = { ...currentFilters };

  // Forget previous "tags" and "user_name" and use value from query params
  // only. (If "tags" and "user_name" are removed from query params, let it be
  // unset.)
  delete entriesRequestFilters.tags;
  delete entriesRequestFilters.user_name;

  for (const key of Object.keys(parsed)) {
    if (key === "q") {
      entriesRequestFilters.q = firstQueryValue(parsed, key);
    } else if (key === "tags") {
      entriesRequestFilters.tags = allQueryValues(parsed, key);
    } else if (key === "user_name") {
      const username = firstQueryValue(parsed, key);
      if (username !== deletedUsername) {
        entriesRequestFilters.user_name = username;
      }
    } else if (key === "page") {
      entriesRequestFilters.page = parseInt(firstQueryValue(parsed, key), 10);
    } else if (key === "order") {
      const order = firstQueryValue(
        parsed,
        key
      ) as EntriesRequestFilters["order"];
      const time_range = firstQueryValue(parsed, "time_range");

      switch (order) {
        case "trending":
          switch (time_range) {
            case "1h":
            case "4h":
            case "24h":
              entriesRequestFilters = {
                ...entriesRequestFilters,
                order: "trending",
                time_range,
              };
              break;
            default:
              entriesRequestFilters = {
                ...entriesRequestFilters,
                order: "trending",
                time_range: "4h",
              };
          }
          break;
        case "favorites":
          switch (time_range) {
            case "24h":
            case "7d":
            case "30d":
            case "all":
              entriesRequestFilters = {
                ...entriesRequestFilters,
                order: "favorites",
                time_range,
              };
              break;
            default:
              entriesRequestFilters = {
                ...entriesRequestFilters,
                order: "favorites",
                time_range: "7d",
              };
          }
          break;
        case "created_at":
          switch (time_range) {
            case "all":
            default:
              entriesRequestFilters = {
                ...entriesRequestFilters,
                order: "created_at",
                time_range: "all",
              };
          }
          break;
        case "name":
          entriesRequestFilters = {
            ...entriesRequestFilters,
            order: "name",
            time_range: undefined,
          };
          break;
        case undefined:
          break;
        default:
          assertUnreachable(order);
      }
    }
  }

  return entriesRequestFilters;
};
